const ToolbarDivider = ({ length = "20px" }) => {
  return (
    <div
      style={{
        height: length,
        width: "0px",
        borderLeft: "1px solid #ccc",
        margin: "0 4px",
      }}
    />
  );
};

export default ToolbarDivider;
